module.exports = __webpack_public_path__ + "img/ORR.4cb17e2c.svg";